const DEFAULT_DELAYED_TIME = 500;
export const DEBOUNCE = (callback, delayTime = DEFAULT_DELAYED_TIME) => {
    let timeout = null;

    return (...args) => {
        const later = () => {
            timeout = null;
            callback(...args);
        }

        clearTimeout(timeout);

        timeout = setTimeout(later, delayTime);
    }
}